export default __webpack_public_path__ + "static/media/photoshop.1114b31f.svg";